import { useContext } from "react";
import { usePermission, useStatusSelect } from "../../../shared";
import { useBasicDetails } from "./useBasicDetails";
import { useIngredients } from "./useIngredients";
import { useRecipeStatusUpdateQueries } from "./useRecipeStatusUpdateQueries";
import { AppContext } from "../../../store";

export const useRecipeDetails = ({ recipeId, isCostPricing }) => {
  const { globalData } = useContext(AppContext);
  const isEditable = usePermission("recipe-modify");
  const isStatusChange = usePermission("recipe-status_change");
  const isStoreAssign = usePermission("recipe-assign_store");
  const isRecipeTipsAndTricks = usePermission("recipe-tips_tricks-view");
  const { ingredientQuery } = useIngredients({
    recipeId: recipeId,
    isCostPricing:
      isCostPricing &&
      recipeId !== undefined &&
      recipeId !== null &&
      recipeId > 0,
  });

  const { basicDetailsQuery, downloadRecipe } = useBasicDetails({ recipeId });
  const {
    updateRecipeStatusMuate,
    errorState,
    setErrorState,
    updateRecipeStatusFromTemplates,
  } = useRecipeStatusUpdateQueries({
    recipeId,
  });

  const onChangeStatusHandler = (value) => {
    updateRecipeStatusMuate.mutate({ recipeId, status: value });
  };
  const selectStatus = useStatusSelect({ onChangeStatusHandler });
  const handleClose = () => {
    setErrorState((draft) => {
      draft.isOpen = false;
    });
  };
  const handleRecipeDownload = (id) => {
    downloadRecipe.mutate({ recipeId: id });
  };

  const onUpdateRecipeStatusFromTemplates = () => {
    updateRecipeStatusFromTemplates.mutate({ recipeId, handleClose });
  };
  return {
    ingredientQuery,
    basicDetailsQuery,
    selectStatus,
    onChangeStatusHandler,
    updateRecipeStatusMuate,
    isEditable,
    isStatusChange,
    isRecipeTipsAndTricks,
    isStoreAssign,
    errorState,
    handleClose,
    globalData,
    handleRecipeDownload,
    downloadRecipe,
    onUpdateRecipeStatusFromTemplates,
    forceInactiveLoading: updateRecipeStatusFromTemplates.isPending,
  };
};
